import type { QueryClient } from '@tanstack/react-query';
import { PROJECT_COMMENT_QUERY_KEYS, type CommentTargetRef } from '@/entities/project-comment';

export function invalidateCommentAnnotations(
  queryClient: QueryClient,
  projectId: string,
  target: CommentTargetRef,
): void {
  void queryClient.invalidateQueries({
    queryKey: PROJECT_COMMENT_QUERY_KEYS.annotations(projectId, target.targetType, target.targetId),
  });
}
